const DATE_PATTERN = /^(\d{2})\/(\d{2})\/(\d{4})$/;
const DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;

const parseDate = value => {
  if (!value) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : new Date(value.getTime());
  }

  const match = String(value).match(DATE_PATTERN);
  if (match) {
    const [, day, month, year] = match;
    return new Date(Number(year), Number(month) - 1, Number(day));
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatPostSaleDate = value => {
  const date = parseDate(value);
  return date
    ? new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).format(date)
    : null;
};

export const formatPostSaleTime = value => {
  const date = parseDate(value);
  return date
    ? new Intl.DateTimeFormat('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
      }).format(date)
    : null;
};

export const elapsedPostSaleDays = (value, today = new Date()) => {
  const start = parseDate(value);
  const end = parseDate(today);
  if (!start || !end) return 0;

  return Math.max(
    0,
    Math.floor(
      (end.setHours(0, 0, 0, 0) - start.setHours(0, 0, 0, 0)) /
        DAY_IN_MILLISECONDS
    )
  );
};

export const elapsedPostSaleDaysClass = days => {
  if (days > 15) return 'text-red-600';
  if (days > 5) return 'text-yellow-600';
  return 'text-emerald-600';
};

export const postSaleDeadlineClass = bucket =>
  ({
    vermelhos: 'border-red-200 bg-red-50 text-red-700',
    laranjas: 'border-orange-200 bg-orange-50 text-orange-700',
    amarelos: 'border-yellow-200 bg-yellow-50 text-yellow-700',
    em_dia: 'border-green-200 bg-green-50 text-green-700',
    sem_prazo: 'border-slate-200 bg-slate-50 text-slate-600',
  })[bucket] || 'border-slate-200 bg-slate-50 text-slate-600';
